import { render, staticRenderFns } from "./menuDrawer.vue?vue&type=template&id=638bd152&scoped=true"
import script from "./menuDrawer.vue?vue&type=script&lang=js"
export * from "./menuDrawer.vue?vue&type=script&lang=js"
import style0 from "./menuDrawer.vue?vue&type=style&index=0&id=638bd152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638bd152",
  null
  
)

export default component.exports